import { render } from "./OnlineStore.vue?vue&type=template&id=3b11d9c5&scoped=true"
import script from "./OnlineStore.vue?vue&type=script&lang=js"
export * from "./OnlineStore.vue?vue&type=script&lang=js"

import "./OnlineStore.vue?vue&type=style&index=0&id=3b11d9c5&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3b11d9c5"

export default script